"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformAPISponsor = exports.transformAPIHacker = exports.transformHacker = exports.transformSponsor = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */

var humps_1 = __importDefault(require("humps"));

function transformSponsor(data) {
  return humps_1.default.decamelizeKeys(data);
}

exports.transformSponsor = transformSponsor;

function transformHacker(payload) {
  var transformedKeys = humps_1.default.decamelizeKeys(payload);
  return Object.assign({}, transformedKeys);
}

exports.transformHacker = transformHacker;

function transformAPIHacker(data) {
  var tranformedKeys = humps_1.default.camelizeKeys(data);

  if (data.isaccepted) {
    tranformedKeys.isAccepted = data.isaccepted;
  }

  return tranformedKeys;
}

exports.transformAPIHacker = transformAPIHacker;

function transformAPISponsor(sponsor) {
  return humps_1.default.camelizeKeys(sponsor);
}

exports.transformAPISponsor = transformAPISponsor;